import React, { useEffect, useRef, useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';
import './Typeright.css';
import cv from '../cv.png';

const Typeright = () => {
  const [isVisible, setIsVisible] = useState(false);
  const typerightRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const node = typerightRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  return (
    <div className="hero-container" ref={typerightRef}>
      <div className="hero-text">
        <h1 className={isVisible ? 'fade-in-left' : 'fade-out-left'}>
          Hey there,
        </h1>
        <h1 className={isVisible ? 'fade-in-left' : 'fade-out-left'}>
          I'm Shashank Venkat.
        </h1>
        <h2 className="hero-typewriter">
          <span className={isVisible ? 'fade-in-left' : 'fade-out-left'}>
            <Typewriter
              words={[
                'Dancer',
                'Machine Learning Researcher',
                'Full Stack Developer',
                'IT Analyst',
                'Space Lover',
                'History Geek'
              ]}
              loop={true}
              cursor
              cursorStyle='|'
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </span>
        </h2>
        <div className={`hero-cta ${isVisible ? 'fade-in-left' : 'fade-out-left'}`}>
          <a
            href='https://drive.google.com/file/d/1tBCnatqmF-EF00d2Ks_IcsSQ6oXl1JuV/view?usp=sharing'
            className="resume-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>View Resume</span>
            <img className='resume-icon' src={cv} alt="Resume" />
          </a>
        </div>
      </div>
      <div className={`hero-image ${isVisible ? 'fade-in-right' : 'fade-out-right'}`}>
        <img
          src="tTBWByQwdtDAxTvZT4ADi-transformed.png"
          alt="Profile"
        />
      </div>
    </div>
  );
};

export default Typeright;
